













































































import { defineComponent, computed, inject } from '@vue/composition-api'
import MediaItem from '@/views/dashboard/components/media/MediaItem/MediaItem.vue'
import {
  deleteFileVersion,
  changeFileVersionStatus,
  mediaItemFileVersionLink,
} from '@/shared/api'
import { alertSymbol } from '@/shared/state-management/symbols'
import { formatTimestamp } from '@/shared/utils'
import {
  ARCHIVED,
  FOR_APPROVAL,
  PUBLISHED,
  WORK_IN_PROGRESS,
} from '@/shared/media/fileVersionStatus'

const statusActions = [
  {
    title: 'archivieren',
    status: ARCHIVED,
  },
  {
    title: 'veröffentlichen',
    status: PUBLISHED,
  },
  {
    title: 'zur Freigabe',
    status: FOR_APPROVAL,
  },
  {
    title: 'in Arbeit',
    status: WORK_IN_PROGRESS,
  },
]

export default defineComponent({
  name: 'FileVersions',
  components: {
    MediaItem,
  },
  props: {
    mediaItem: Object,
  },
  setup(props, { root, emit }) {
    const sortedFileVersions = computed(() => {
      if (!(props.mediaItem && props.mediaItem.fileVersions)) {
        return []
      }

      return [...props.mediaItem.fileVersions].sort(
        (a: { createdOn: string }, b: { createdOn: string }) => {
          return (
            new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()
          )
        }
      )
    })

    const $alert = inject(alertSymbol) as Function

    const deleteItem = async (
      mediaItemId: string,
      fileVersion: {
        id: string
        name: string
      }
    ): Promise<void> => {
      await $alert({
        text: root.$t('fileVersions.confirmDelete'),
        type: 'confirm',
      })
      await deleteFileVersion(mediaItemId, fileVersion.id)
    }

    const changeStatus = async (fileVersionId: string, status: string) => {
      const newMediaItem = await changeFileVersionStatus(
        props.mediaItem.id,
        fileVersionId,
        status
      )
      emit('update-media-item', newMediaItem)
    }

    const translateStatus = (statusString: string): string => {
      switch (statusString) {
        case ARCHIVED:
          return root.$t('fileVersions.status.archived') as string
        case FOR_APPROVAL:
          return root.$t('fileVersions.status.forApproval') as string
        case PUBLISHED:
          return root.$t('fileVersions.status.published') as string
        case WORK_IN_PROGRESS:
          return root.$t('fileVersions.status.workInProgress') as string
      }
      return statusString
    }

    return {
      sortedFileVersions,
      formatTimestamp,
      deleteItem,
      statusActions,
      changeStatus,
      translateStatus,
      mediaItemFileVersionLink,
    }
  },
})
